import { VariantType } from 'notistack';
import randomString from 'random-string';
import { Dispatch } from 'redux';
import { Notification } from '../reducer/notification';
import * as notificationActions from './notificationAction';

// This returns a redux-thunk action (a function).
export const notify = ({ type = 'default', text, timeout=3000 }:{type?:VariantType,text:string,timeout?:number}) =>
{
	if (!timeout)
	{
		switch (type)
		{
			case 'info':
				timeout = 3000;
				break;
			case 'error':
				timeout = 10000;
				break;
			default:
				timeout = 3000;
				break;
		}
	}

	const notification:Notification =
	{
		id      : randomString({ length: 6 }).toLowerCase(),
		type    : type,
		text    : text,
		timeout : timeout
	};

	return (dispatch:Dispatch) =>
	{
		dispatch(notificationActions.addNotification(notification));

		setTimeout(() =>
		{
			dispatch(notificationActions.removeNotification(notification.id));
		}, timeout);
	};
};


export const warning = (text:string) =>
{
	const timeout = 3000;
	const notification:Notification =
	{
		id      : randomString({ length: 6 }).toLowerCase(),
		type    : "warning",
		text    : text,
		timeout
	};

	return (dispatch:Dispatch) =>
	{
		dispatch(notificationActions.addNotification(notification));
		setTimeout(() =>
		{
			dispatch(notificationActions.removeNotification(notification.id));
		}, timeout);
	};
};


export const info = (text:string) =>
{
	const timeout = 3000;
	const notification:Notification =
	{
		id      : randomString({ length: 6 }).toLowerCase(),
		type    : "default",
		text    : text,
		timeout
	};

	return (dispatch:Dispatch) =>
	{
		dispatch(notificationActions.addNotification(notification));
		setTimeout(() =>
		{
			dispatch(notificationActions.removeNotification(notification.id));
		}, timeout);
	};
};